// extracted by mini-css-extract-plugin
export default {"loginFormForgot":"signup_loginFormForgot__+V4+A","ant-col-rtl":"signup_ant-col-rtl__iVNHJ","loginFormButton":"signup_loginFormButton__WCz76"};